import router from "@/router";
import {convertDate, copyTextToClipboard, getValue, goToFireStore} from "@/globalFunctions";
import {MessageBox} from "element-ui";
import i18n from "@/lang";
import {UserModule} from "@/store/modules/user";
import {LicenseModule} from "@/store/modules/license";

export const filters = [
    {
        field:"active",
        clearable: true,
        options: [
            { key: true, label: 'table.status-active' },
            { key: false, label: 'table.status-inactive' }
        ],
        placeholder: 'table.status'
    },
    {
        field:  "type",
        clearable: true,
        options: [
            { key: null, label: 'None' },
            { key: "trial", label: 'table.types.trial' },
            { key: "monthly", label: 'table.types.monthly' },
            { key: "one-time", label: 'table.types.0ne-time' },
            { key: "read-only", label: 'table.types.read-only' }
        ],
        placeholder: 'table.type'
    },{
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.company-asc', key: 'Company.Name-asc' },
            { label: 'table.order.company-desc', key: 'Company.Name-desc' },
            { label: 'table.order.start-date-asc', key: 'Subscription.StartDate-asc' },
            { label: 'table.order.start-date-desc', key: 'Subscription.StartDate-desc' },
            { label: 'table.order.end-date-asc', key: 'Subscription.EndDate-asc' },
            { label: 'table.order.end-date-desc', key: 'Subscription.EndDate-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.license-id',
        field: "Id",
    },
    {
        label: 'table.company-name',
        field: "Billing.Name",
    },
    {
        label: 'table.status',
        field: "Active",
        translate: true,
        formatter: (x : any) => {
            return (x ? 'table.active' : 'table.inactive');
        },
        tag: true,
        tagType: (x : any) => {
            return (x ? 'success' : 'danger')
        }
    },
    {
        label: 'table.start-date',
        field: 'Subscription.StartDate',
        formatter: (x : any) => {
            return convertDate(x)?.toISOString().split("T")[0];
        }
    }
];

export const actions = [
    {
        label: 'table.register',
        command: "register",
        icon: "app_registration",
        type: 'success',
        click: (row : any) => {
            copyTextToClipboard(window.provider.Platform.Endpoints.Register + "?licenseId=" + row.Id + "&accessToken=" + row.AccessToken);
            window.GlobalEvents.$emit("notify", {
                type: "success",
                title: i18n.t("notifications.text-copied.title"),
                message: i18n.t("notifications.text-copied.message")
            });
        }
    },
    {
        label: 'table.edit',
        command: "edit",
        icon: "edit",
        type: 'info',
        click: (row : any) => {
            router.push("/admin/licenses/" + row.Id);
        }
    },
    {
        label: 'table.impersonate',
        command: "impersonate",
        icon: "login",
        type: 'primary',
        click: (row : any) => {
            UserModule.Impersonate(row.Id);
        }
    },
    {
        label: 'table.firestore',
        command: "toFireStore",
        icon: "local_fire_department",
        type: 'warning',
        click: (row : any) => {
            goToFireStore({
                type: "license",
                licenseId: row.Id
            });
        }
    },
    {
        label: 'table.delete',
        command: "delete",
        icon: 'delete',
        type: 'danger',
        click: (row : any) => {
            MessageBox({
                title: i18n.t('confirmations.delete-license.title').toString(),
                message: i18n.t('confirmations.delete-license.text').toString(),
                showCancelButton: true,
                confirmButtonClass: "el-button--info",
                cancelButtonClass: "el-button--danger",
                confirmButtonText: i18n.t('confirmations.default.confirmation-button').toString(),
                cancelButtonText: i18n.t('confirmations.default.cancel-button').toString(),
            }).then(async () => {
                window.GlobalEvents.$emit("start-list-load");
                return LicenseModule.list.archive(row.Id).then(() => {
                    window.GlobalEvents.$emit("refresh-list");
                })
            });
        }
    }
];

export const getData = async (listQuery : any) => {
    // Get items
    if (!LicenseModule.list._retrieved || !LicenseModule.list._admin){
        await LicenseModule.list.get(true)
    }

    let items = LicenseModule.list.toList();

    // Query
    if (listQuery.active === true || listQuery.active === false){
        items = items.filter((x) => x.Active === listQuery.active);
    }

    if (listQuery.type){
        items = items.filter((x) => x.Subscription.Type === listQuery.type);
    }

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
